import { memo } from 'react'
import SectionWrapper from '../SectionWrapper'

const ConditionalSection = memo(
  ({ condition, children, fallback = null, ...sectionProps }) => {
    if (!condition) {
      return fallback
    }

    return <SectionWrapper {...sectionProps}>{children}</SectionWrapper>
  }
)

export default ConditionalSection
